import PartialServiceCallbackDialog from "../../../src/features/partialService/PartialServiceCallbackDialog";
import PartialServiceResetDialog from "../../../src/features/partialService/PartialServiceResetDialog";
import { useAppSelector } from "../../../src/hooks";
import { PartialServiceDialogKind } from "../../features/partialService/partialServiceUtils";

const PartialServiceDialogSwitcher: React.FC<{}> = () => {
    const partialServiceState = useAppSelector(state => state.partialService);

    switch (partialServiceState.partialServiceDialogKind) {
        case PartialServiceDialogKind.Reset:
            return <PartialServiceResetDialog />
        case PartialServiceDialogKind.Callback:
            return <PartialServiceCallbackDialog />
        case PartialServiceDialogKind.None:
            return null;
    }
}

export default PartialServiceDialogSwitcher;